import * as UI from "@accurx/design";
import styled from "styled-components";

export const StyledContainer = styled(UI.Flex)<{ $fadeIn: boolean }>`
    margin: 128px ${UI.Tokens.SIZES[6]} 0px ${UI.Tokens.SIZES[6]};

    text-align: center;
`;
